/**
  table内部cell中的动态输入组件

*/
//
// import {
//   nodes
// }
// from "../form-create/core/cvm"
//

import objectUtil from '../../static/js/objectUtil'
import templateUtil from '../../static/js/templateUtil'
// import validateConverterUtil from './libs/validateConverterUtil';
import dynamicItemUtil from './libs/dynamicItemUtil'
import compileVariableUtil from '../../static/js/compileVariableUtil'
import dynamicFromItem from './dynamicFromItem.vue'
import FormItem from './form-item.vue'
// import vueUtils from '../../static/js/vueUtils';

// 采用dynamicFromItem包装验证框架的组件数组
let dynamicFromItemArr = ['addressInfoEdit', 'addressEdit', 'proportionInput']

export default {
  name: 'formItemDynamic',
  inject: ['dynamicFromProvide'],
  components: {
    dynamicFromItem,
    FormItem,
  },
  props: {
    store: {
      type: Object,
      default: null,
    },
    //id前缀
    idPrefix: {
      type: String,
      default: 'idPrefix',
    },
    // cell 定义，重点判断是否有输入值组件定义
    editformItem: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    value: null,
    useBackCount: {
      //用于价格管理中反算
      type: String,
      default: null,
    },
    showTopBtn: {
      type: Boolean,
      default: false,
    },
    formDataChangeItems: {
      //将formData的数据与items关联
      type: String,
      default: null,
    },
    extendCompile: Object,
  },
  data() {
    this.parentDataKey = objectUtil.getValueByPath(
      this.store,
      'states.parentDataKey',
      'parentFormData'
    )
    return {
      data: this.value,
    }
  },
  watch: {
    value(val) {
      this.data = val
    },
  },

  beforeDestroy() {
    //vueUtils.removeAtt(this.data);
    // console.log('formItemDynamic:beforeDestroy');
    this.data = null
  },

  methods: {
    /**
          包装到验证框架itemform中。
          @param {function} render 渲染方法
          @param {object} editformItem 元素定义
          @param {array} children 子元素列表

        */
    createItemForm(h, editformItem, children) {
      var propsData = {
        key: editformItem.field + editformItem.title,
        prop: editformItem.field,
        label: editformItem.title,
        labelTip: editformItem.labelTip,
        // labelFor: refName,
        rules: editformItem.required
          ? editformItem.validate
          : editformItem.validate.map((item) => {
              // item.required = false
              return { ...item, required: false }
            }),
      }
      //  console.log("createItemForm", propsData);

      var vNodeFn = h(
        'form-item',
        {
          class: { 'title-item': editformItem.props && editformItem.props.titleItem }, //用于在表单项的label需要作为标题的情景
          props: propsData,
        },
        children
      )
      return vNodeFn
    },

    /**
          包装到验证框架dynamicFromItem中。
          @param {function} render 渲染方法
          @param {object} editformItem 元素定义
          @param {array} children 子元素列表

        */
    createDynamicFromItem(h, editformItem, children) {
      var propsData = {
        key: editformItem.field + editformItem.title,
        prop: editformItem.field,
        label: editformItem.title,
        // labelFor: refName,
        rules: editformItem.required
          ? editformItem.validate
          : editformItem.validate.map((item) => {
              item.required = false
              return item
            }),
      }
      //  console.log("createItemForm", propsData);

      var vNodeFn = h(
        'dynamic-from-item',
        {
          props: propsData,
        },
        children
      )
      return vNodeFn
    },

    /**
          包装到布局组件中
          @param {function} render 渲染方法
          @param {object} editformItem 元素定义
          @param {array} children 子元素列表
        */
    createLayout(h, layout, children) {
      // var _props = layout.props

      var layoutProps = null
      if (layout.props) {
        layoutProps = Object.assign({}, layout.props)
      } // 避免使用观察数据对象作为VNoad数据

      var vNodeFn = h(
        layout.type,
        {
          props: layoutProps,
        },
        children
      )
      return vNodeFn
    },

    /**
          包装到布局组件中
          @param {function} render 渲染方法
          @param {object} editformItem 元素定义
          @param {array} children 子元素列表
        */
    createDraggableContainer(h, editformItem, children, isInline, ifDrag) {
      var options = this.dynamicFromProvide.options

      var propsData = {
        visible: editformItem.visible,
        inline: isInline,
        data: editformItem.code,
        dataItems: editformItem,
        selectdField: this.store ? this.store.states.selectdFieldName : null,
        ifDrag: ifDrag,
      }

      var optionOn = {
        drop: (value) => {
          //  alert("drop,value");
          options.designOptions.handlerDrop(value)
        },
        click: (value, items) => {
          //  alert("drop,value");
          options.designOptions.handlerClick(value, items)
        },
        dblclick: (value) => {
          //  alert("drop,value");
          options.designOptions.handlerDbclick(value)
        },
      }

      var vNodeFn = h(
        'draggable-container',
        {
          props: propsData,
          on: optionOn,
        },
        children
      )
      return vNodeFn
    },
    // 判断oldValue newValue是否相同
    isEqual(oldValue, newValue) {
      const isLike =
        typeof oldValue === 'object' && typeof newValue === 'object'
          ? JSON.stringify(oldValue) === JSON.stringify(newValue)
          : oldValue === newValue
      return isLike
    },
  },
  render(h) {
    var _vm = this
    var item = this.editformItem
    var isDesign = objectUtil.getValueByPath(
      this.dynamicFromProvide || {},
      'options.designOptions.design'
    )
    // console.info(item.code,'code:form-control....rendered...')
    if (!isDesign) {
      if (item.hasOwnProperty('visible') && !item.visible) return null
    }
    var componentCode = 'readText'
    if (item.type) componentCode = item.type
    var componentClassName = dynamicItemUtil.convertComponentName(componentCode)
    var data = this.value
    var _props = item.props
    var field = item.field

    // 如果设置只读模式，则优先级最高。
    if (this.disabled) {
      if (!_props) _props = {}
      _props.disabled = this.disabled
    }
    //将panguForm组件中的标签和分组在可视化编辑时展示为标题
    if (componentClassName === 'formTag' || componentClassName === 'formGroup') {
      componentClassName = 'groupLabel'
      item.title = null
      item.props.title = item.name
    }
    var propsCompileData = compileVariableUtil.getCompileVariable(data, this)
    if (this.extendCompile) {
      propsCompileData.extendCompile = this.extendCompile
    }
    // 兼容老版本，命名错误
    propsCompileData.parentData = propsCompileData.paretData = window[this.parentDataKey]

    if (propsCompileData && propsCompileData.paretData) {
      //设置一个变量_formDataChangeItems存入formData中
      propsCompileData.paretData = {
        ...propsCompileData.paretData,
        _formDataChangeItems: this.formDataChangeItems,
      }
    }

    if (!isDesign) {
      //支持是否显示和显示表达式
      const showRegex = item.show ? templateUtil.compileData(item.show, propsCompileData) : true
      if (!showRegex) return null
    }

    let propsCompile = null
    try {
      propsCompile = templateUtil.compileData(_props, propsCompileData)
    } catch (e) {
      propsCompile = _props
    }
    //  console.log("render propsCompile", propsCompile, item);
    //  console.log("objectUtil.getValueByPath(data, field)", field, objectUtil.getValueByPath(data, field), data);
    if (!propsCompile) propsCompile = {}
    var optionModel = null
    if (field) {
      var initValue = objectUtil.getValueByPath(this.data, field, 'hasOwnProperty')
      // 如果复杂结构体null，则初始化空对象，避免 vue v-model 检测报错bug。
      if (
        initValue === 'hasOwnProperty' &&
        field.indexOf('.') > 0 &&
        componentCode !== 'readText'
      ) {
        initValue = null
        if (!this.data) this.data = {}
        objectUtil.setValueByPathForVue(this.data, field, initValue, _vm)
        // console.error('hasOwnProperty-form', field);
      } else if (initValue === 'hasOwnProperty') {
        initValue = null
      }

      optionModel = {
        value: initValue,
        callback: (modelValue, isInitData) => {
          // if(typeof modelValue === "string"){
          //   modelValue = modelValue.replace(/\s*/g,"");
          // }
          if (propsCompile.disabled) {
            return
          }
          var oldValue = objectUtil.getValueByPath(this.data, field)
          if (!this.data) this.data = {}
          objectUtil.setValueByPathForVue(this.data, field, modelValue, _vm)

          //价格管理中计算
          if (this.useBackCount && this.store) {
            this.store.dispatch(this.useBackCount, field, this.data)
          }
          this.$emit('input', this.data)
          this.$emit('on-change', modelValue, field)
          if (!this.isEqual(oldValue, modelValue)) {
            this.$emit('form-control', field) // 后续可能优化为可控抛事件
            if (item.props && item.props.changeBorthers) {
              let temp = {}
              Object.keys(item.props.changeBorthers).forEach((im) => {
                let otherFields = item.props.changeBorthers[im]
                if (!otherFields) {
                  temp[im] = otherFields
                } else if (otherFields.startsWith('{{') && otherFields.endsWith('}}')) {
                  temp[im] = templateUtil.compileData(otherFields, propsCompileData)
                } else {
                  temp[im] = objectUtil.getValueByPath(modelValue, otherFields)
                }
              })
              console.log('******sideSelect***this.changeBorthersObj***********', this.temp)
              Object.keys(temp).forEach((im) => {
                //修改人员的时候会给部门赋值，需要执行部门值修改的监听方法
                let tempOldValue = objectUtil.getValueByPath(this.data, im)
                objectUtil.setValueByPathForVue(this.data, im, temp[im], _vm)
                if (this.dynamicFromProvide && this.dynamicFromProvide.options) {
                  emitInputHandle(
                    this.dynamicFromProvide.options.watchInputHandle,
                    im,
                    temp[im],
                    tempOldValue,
                    this.data,
                    this,
                    propsCompile
                  )
                }
              })
            }
          }

          if (this.dynamicFromProvide && this.dynamicFromProvide.options) {
            // 是否启用 未保存提示。
            if (!isInitData && this.dynamicFromProvide.options.saveTipFlag) {
              if (window.$vueApp && window.$vueApp.$store) {
                if (window.$vueApp.$store.state.menuStore) {
                  var currentRouter = window.$vueApp.$store.state.menuStore.currentRouter
                  if (currentRouter && currentRouter.id) {
                    // 在侧滑里面的时候抛出事件 fpr
                    if (
                      this.dynamicFromProvide.$parent &&
                      this.dynamicFromProvide.$parent.$parent.onSide
                    ) {
                      let parent = this.dynamicFromProvide.$parent.$parent
                      //兼容crudEditForSideModal情况
                      if (parent.sideItemDynamicOnModify) {
                        parent.sideItemDynamicOnModify()
                      } else {
                        parent.$emit('side-item-dynamic-on-modify')
                      }
                    } else {
                      window.$vueApp.$store.commit('setFormModifyBy', currentRouter.id)
                    }
                  }
                }
              }
            }

            emitInputHandle(
              this.dynamicFromProvide.options.watchInputHandle,
              field,
              modelValue,
              oldValue,
              this.data,
              this,
              propsCompile
            )
          }
        },
      }
    } else {
      // console.log("optionModel is null.field=", field);
    }
    // 给每个子组件传一个 唯一标识进组件，方便子组件区分
    propsCompile.conCode = field
    propsCompile.showTopBtn = this.showTopBtn // 自动把编辑页 是否显示顶部按钮props参数传入
    //将crudEdit组件中的store向下传递
    if (this.store) propsCompile.store = this.store
    // 解决表格验证时没有配置rowDataKey属性报错
    if (componentClassName == 'crudArray') {
      if (propsCompile && !propsCompile.rowDataKey) {
        propsCompile.rowDataKey = field
      }
    }
    //当为input组件时支持设置maxlength
    if (item.length > 0 && ~['input', 'i-input', 'Input'].indexOf(componentClassName)) {
      propsCompile.maxlength = propsCompile.maxlength ?? item.length
    }
    if (item.disabled) {
      propsCompile.disabled = item.disabled
    }
    let itemEvent = objectUtil.clone(item.event) // 解决修改v-for循环变量值引起的错误提示

    if (propsCompile && propsCompile.onBlur && (!itemEvent || !itemEvent.onBlur)) {
      if (!itemEvent) itemEvent = {}
      itemEvent['on-blur'] = () => {
        let newValue = objectUtil.getValueByPath(this.data, field)
        this.$emit('on-blur', newValue, field)
      }
    }
    if (this.useBackCount && this.store) {
      //价格管理中计算
      if (!itemEvent) itemEvent = {}
      itemEvent['on-change'] = (fildKey, field) => {
        //价格管理中计算
        this.store.dispatch(this.useBackCount, field, this.data, {}, fildKey)
      }
    }
    if (
      (componentClassName == 'panguInputNumber' || componentClassName == 'i-input') &&
      (!itemEvent || !itemEvent['on-enter'])
    ) {
      if (!itemEvent) itemEvent = {}
      itemEvent['on-enter'] = () => {
        let newValue = objectUtil.getValueByPath(this.data, field)
        this.$emit('on-enter', newValue, field)
      }
      // itemEvent['on-keyup'] = () => {
      //     debugger
      //     let newValue = objectUtil.getValueByPath(this.data,
      //         field);
      //     this.$emit('keyup-enter', newValue, field);
      // };
    }

    const vNodeParam = {
      attrs: {
        id: componentClassName == 'groupLabel' ? item.code : this.idPrefix + '_' + item.code,
      },
      style: templateUtil.compileData(item.style, propsCompileData), // 表单配置的自定义样式支持动态切换
      on: itemEvent, // 增加事件监听
      model: optionModel,
    }
    // #8406 form-item 增加 props.labelTip ，在可在表单项组件的【扩展参数】中配置并传递给 form-item，但不传递给表单项组件
    const { labelTip, ..._propsComile } = propsCompile
    item.labelTip = labelTip ?? item.labelTip
    //如果是component-plus库中的组件，将属性都渲染在attrs中
    if (componentClassName.indexOf('Pg') > -1) {
      vNodeParam.attrs = { ...vNodeParam.attrs, ..._propsComile }
    } else {
      vNodeParam.props = _propsComile
    }

    var vNodeFn = h(componentClassName, vNodeParam)

    var isInline = true
    // add by lmq 没标题时，不加FormItem

    // 默认没有标题的换行，不适用inline
    if (!item.title) {
      isInline = false
      if (item.props && item.props.inline) {
        isInline = item.props.inline
      }
    }

    // 第一层包装   验证

    if (dynamicFromItemArr.indexOf(componentClassName) > -1) {
      vNodeFn = this.createDynamicFromItem(h, item, [vNodeFn])
    } else {
      isInline && (vNodeFn = this.createItemForm(h, item, [vNodeFn]))
    }

    /* if (isInline && dynamicFromItemArr.indexOf(componentClassName) == -1) {
            vNodeFn = this.createItemForm(h, item, [vNodeFn]);
        }

        if (dynamicFromItemArr.indexOf(componentClassName) > -1) {
            vNodeFn = this.createDynamicFromItem(h, item, [vNodeFn]);
        } */

    /// /第二层包装 包装IconDiv
    if (_props && _props.layout && _props.layout.type) {
      vNodeFn = this.createLayout(h, _props.layout, [vNodeFn])
    }

    if (isDesign) {
      var ifDrag = objectUtil.getValueByPath(
        this.dynamicFromProvide || {},
        'options.designOptions.ifDrag',
        true
      )
      vNodeFn = this.createDraggableContainer(h, item, [vNodeFn], isInline, ifDrag)
    }

    return vNodeFn
  },
}

/**
  v-model 触发input事件，回调注入的钩子函数，处理特殊业务。
 * @param {object} watchInputHandle 监听的属性输入变化的Map定义《属性名：回调方法）；
 * @param {String} field 监听的属性名
 * @return {boolean}

  path=“obj.valu1”  =>return true
*/
const emitInputHandle = function (
  watchInputHandle,
  field,
  newValue,
  oldValue,
  formData,
  vue,
  propsCompile
) {
  if (!watchInputHandle) return
  var wacthFN = watchInputHandle[field]

  if (typeof wacthFN !== 'function') {
    return
  }
  let tableNotChange = wacthFN(newValue, oldValue, formData, propsCompile.addToWhere || 'items')
  if (!tableNotChange) {
    vue.dynamicFromProvide.broadcast('panguTable', 'on-table-change')
  }
}
